import {Pipe, PipeTransform} from '@angular/core';
import {CacheService} from '../core/cache.service';
import {keyBy} from 'lodash-es';

@Pipe({
  name: 'material'
})
export class MaterialPipe implements PipeTransform {

  materials;

  constructor(private cache: CacheService) {
    this.materials = keyBy(this.cache.getCache('itemCodeMaster').filter(c => c.cmType === 'M'), 'cmCode');
  }

  transform(value: string, ...args: unknown[]): unknown {
    return this.materials[value] ? this.materials[value].cmDesc : value;
  }

}
